
import * as ActionTypes from '../actionTypes';

export default (state={},action) => {

    switch(action.type){
        case ActionTypes.REQUEST_ALL_USERS_DATA:                
            return {
                ...state,
                loading:true,
                error:false,
                errorInfo:null
            }        
        case ActionTypes.RECEIVED_ALL_USERS_DATA:
            return {
                ...state,
                loading:false,
                response:action.res,
                error:false,
                errorInfo:null
            }
        case ActionTypes.ERROR_ALL_USERS_DATA:
            return{
                ...state,
                loading:false,
                error:true,
                errorInfo:action.err
            }
        case ActionTypes.CLEAR_ALL_USERS_DATA:
            return {}
        default: return state;
    }
} 